/**
 * configuration operations
 * 
 * @author    Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


import {
    REST_CALL_LOAD_CONFIGURATION,
    REST_CALL_OBJECT_LIST,
    REST_CALL_SAVE_OBJECT,
    REST_SERVER_BASE_URL
} from "../config";
import {showError} from "./message";
import {updateConfigurationAction, loadUserSettingsAction, changeUserSettingAction} from "../redux/configuration/actions";
import {fetchJSON, fetchJSONActivity} from "./communication";


export function loadConfiguration() {

    return async (dispatch, getState) => {

        try {
            // do server communication
            const response = await fetchJSONActivity(dispatch, "loading configuration",
                REST_SERVER_BASE_URL + REST_CALL_LOAD_CONFIGURATION.path, {
                    method: REST_CALL_LOAD_CONFIGURATION.method,
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            );

            // handle response
            const configuration = response.data;
            if (!configuration) {
                console.log("no configuration found, assuming empty one");
                dispatch(updateConfigurationAction({}));
            }
            else {
                console.log("configuration:", configuration.fields);
                dispatch(updateConfigurationAction(configuration.fields || {}));
            }
        }
        catch (error) {
            showError(error)(dispatch);
        }
    }
}

export function loadUserSettings(userId, name) {

    return async (dispatch, getState) => {

        try {
            const objectId = "usersettings." + userId;

            // do server communication
            const { authorization } = getState();
            const response = await fetchJSONActivity(dispatch, "loading user settings",
                REST_SERVER_BASE_URL + REST_CALL_OBJECT_LIST.path, {
                    method: REST_CALL_OBJECT_LIST.method,
                    body: JSON.stringify({ "id": objectId }),
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + authorization.accessToken
                    }
                }
            );

            // handle response
            const settings = response.items;
            if (!settings || settings.length < 1) {
                console.log("no user settings found, assuming empty one");
                dispatch(loadUserSettingsAction({
                    "id": objectId,
                    "type": "usersettings",
                    "title": "Settings of " + name,
                    "fields": {}
                }));

                // save settings asynchonously
                saveUserSettings(dispatch, getState);
            }
            else {
                console.log("user settings:", settings[0].fields);
                dispatch(loadUserSettingsAction(settings[0]));
            }
        }
        catch (error) {
            showError(error)(dispatch);
        }
    }
}

export function changeUserSetting(fieldId, value) {

    return (dispatch, getState) => {
        // change state immediatelly
        dispatch(changeUserSettingAction(fieldId, value));

        // save settings asynchonously
        saveUserSettings(dispatch, getState);
    }
}

async function saveUserSettings(dispatch, getState) {

    const object = getState().configuration.userSettings;
    if (object.id) {
        try {
            const { authorization } = getState();
            await fetchJSON(
                REST_SERVER_BASE_URL + REST_CALL_SAVE_OBJECT.path, {
                    method: REST_CALL_SAVE_OBJECT.method,
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + authorization.accessToken
                    },
                    body: JSON.stringify(object)
                }
            );
        }
        catch (error) {
            showError(error)(dispatch);
        }
    }
}